export default "__VITE_ASSET__DujVHeQn__"